import { USAState, USAStateAcronym, ZipCode } from '@hc-frontend/core-types';
import { z } from 'zod';

export const FetchGeolocationPayloadDTO = z.object({
  zip: ZipCode,
});

// eslint-disable-next-line no-redeclare
export type FetchGeolocationPayloadDTO = z.infer<
  typeof FetchGeolocationPayloadDTO
>;

export const FetchGeolocationResponseDTO = z
  .object({
    city: z.string(),
    countyId: z.number(),
    countyName: z.string(),
    displayName: z.string(),
    fips: z.string(),
    ssa: z.string(),
    stateAcronym: USAStateAcronym,
    stateId: z.number(),
    stateName: USAState,
    zipCode: ZipCode,
  })
  .array();

// eslint-disable-next-line no-redeclare
export type FetchGeolocationResponseDTO = z.infer<
  typeof FetchGeolocationResponseDTO
>;
